if (!customElements.get('product-ugc-slider')) {
  class ProductUgcSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-ugc-track]');
      this.controls = this.querySelector('[data-ugc-controls]');
      this.prevButton = this.querySelector('[data-ugc-prev]');
      this.nextButton = this.querySelector('[data-ugc-next]');
      this.videos = Array.from(this.querySelectorAll('.main-product-ugc__card video'));

      if (!this.track) return;

      this.handleScroll = this.updateControls.bind(this);
      this.handleResize = this.updateControls.bind(this);
      this.handleVideoPlay = this.pauseSiblingVideos.bind(this);
      this.handleVideoClick = this.toggleVideoPlayback.bind(this);

      this.prevButton?.addEventListener('click', () => this.scrollTrack(-1));
      this.nextButton?.addEventListener('click', () => this.scrollTrack(1));
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);
      this.videos.forEach((video) => {
        video.addEventListener('play', this.handleVideoPlay);
        video.addEventListener('click', this.handleVideoClick);
      });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.track);
      }

      this.updateControls();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      this.videos?.forEach((video) => {
        video.removeEventListener('play', this.handleVideoPlay);
        video.removeEventListener('click', this.handleVideoClick);
      });
      this.resizeObserver?.disconnect();
    }

    pauseSiblingVideos(event) {
      this.videos.forEach((video) => {
        if (video !== event.currentTarget && !video.paused) {
          video.pause();
        }
      });
    }

    toggleVideoPlayback(event) {
      const video = event.currentTarget;
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }

    scrollTrack(direction) {
      const firstCard = this.querySelector('.main-product-ugc__card');
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const amount = (firstCard?.getBoundingClientRect().width || this.track.clientWidth * 0.8) + gap;

      this.track.scrollBy({
        left: amount * direction,
        behavior: 'smooth',
      });
    }

    updateControls() {
      if (!this.controls || !this.prevButton || !this.nextButton) return;

      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const isDesktop = window.matchMedia('(min-width: 768px)').matches;
      const hasOverflow = maxScroll > 4;
      const showControls = isDesktop && hasOverflow;

      this.controls.hidden = !showControls;
      this.prevButton.disabled = !showControls || this.track.scrollLeft <= 4;
      this.nextButton.disabled = !showControls || this.track.scrollLeft >= maxScroll - 4;
    }
  }

  customElements.define('product-ugc-slider', ProductUgcSlider);
}
